import './style.scss';

export function resources_block() {
    const block = document.querySelector('.resources_block');
    if (!block) return;


}
